"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Combobox, ComboboxContent, ComboboxEmpty, ComboboxInput, ComboboxItem, ComboboxList, ComboboxTrigger } from "./combobox";
/**
 * Single-select combobox over free-text string values: suggests the given
 * options, filters as the user types, and offers creating the typed value
 * when it matches no existing option.
 */ export function CreatableCombobox({ options, value, onValueChange, placeholder, allowClear = false, disabled = false, id }) {
    const { t } = useTranslation();
    const [searchQuery, setSearchQuery] = React.useState("");
    const { filteredOptions, isCustomValue } = React.useMemo(()=>{
        const query = searchQuery.toLowerCase();
        const filtered = query ? options.filter((option)=>option.toLowerCase().includes(query)) : options;
        return {
            filteredOptions: filtered,
            isCustomValue: !!query && !options.some((option)=>option.toLowerCase() === query)
        };
    }, [
        options,
        searchQuery
    ]);
    return /*#__PURE__*/ _jsxs(Combobox, {
        value: value,
        onValueChange: (newValue)=>{
            if (typeof newValue === "string") {
                onValueChange(newValue);
            }
            setSearchQuery("");
        },
        onClear: ()=>onValueChange(""),
        disabled: disabled,
        children: [
            /*#__PURE__*/ _jsx(ComboboxTrigger, {
                id: id,
                placeholder: placeholder,
                allowClear: allowClear,
                children: value || null
            }),
            /*#__PURE__*/ _jsxs(ComboboxContent, {
                children: [
                    /*#__PURE__*/ _jsx(ComboboxInput, {
                        placeholder: t("common.searchOrCreate"),
                        value: searchQuery,
                        onValueChange: setSearchQuery
                    }),
                    /*#__PURE__*/ _jsxs(ComboboxList, {
                        children: [
                            filteredOptions.length === 0 && !isCustomValue && /*#__PURE__*/ _jsx(ComboboxEmpty, {
                                children: t("common.noResults")
                            }),
                            isCustomValue && /*#__PURE__*/ _jsxs(ComboboxItem, {
                                value: searchQuery,
                                children: [
                                    t("common.create"),
                                    ' "',
                                    searchQuery,
                                    '"'
                                ]
                            }),
                            filteredOptions.map((option)=>/*#__PURE__*/ _jsx(ComboboxItem, {
                                    value: option,
                                    children: option
                                }, option))
                        ]
                    })
                ]
            })
        ]
    });
}
CreatableCombobox.displayName = "CreatableCombobox";

//# sourceMappingURL=creatable-combobox.js.map